<script setup lang="ts">
const props = defineProps({
  error: {
    type: Object as PropType<Error & { statusCode?: number; statusMessage?: string }>,
    required: true
  }
})

// const router = useRouter()

// if (process.client && props.error.statusCode === 404) {
  //   const statusMsg = props.error.statusMessage || ''
  //   const msg = props.error.message || ''
  //   const totalMsg = `${statusMsg || ''}, ${msg || ''}`
  //   router.replace(`/404?message=${totalMsg}`)
if (import.meta.client && props.error.statusCode === 404) {
  navigateTo('/')
}
</script>

<template>
  <div>Redirecting...</div>
</template>
